import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import SoftBox from 'components/SoftBox';

export default function ControlledRadioButtonsGroup({ label, value, options, setValue, size }) {

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <SoftBox>
      <FormControl>
        <FormLabel id="demo-controlled-radio-buttons-group" sx={{
          "&.Mui-focused": {
            color: "#344767", // Your desired focused color
          },
          fontSize: size == "small" ? '1rem' : '1.2rem'
        }}
        >{label}</FormLabel>
        <SoftBox>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={handleChange}
            row
          >
            {
              options.map(function (value, index) {
                return <FormControlLabel
                  control={<Radio />}
                  label={value.label}
                  value={value.value}
                  sx={{
                    marginLeft: 0,
                    marginRight: 2,
                    alignItems: "center",
                  }}
                />

              })
            }
          </RadioGroup>
        </SoftBox>

      </FormControl>
    </SoftBox >

  );
}